import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ScopeDocumentService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(
                () => this.api.getAll(params),
                { maxRetries: 2 }
            );
            const body = response;
            return {
                success: true,
                data: body.data || [],
                pagination: body.pagination || {},
                uniqueValues: body.uniqueValues || {},
                message: body.message || 'Kapsam belgeleri listesi getirildi'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch scope documents');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch scope document');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıt oluşturuldu'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create scope document');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıt güncellendi'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update scope document');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Kayıt silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete scope document');
        }
    }

    async bulkDelete(ids) {
        const results = { success: [], failed: [] };
        for (const id of ids) {
            try {
                await this.api.delete(id);
                results.success.push(id);
            } catch (error) {
                results.failed.push({ id, error: error.message });
            }
        }
        return {
            success: results.failed.length === 0,
            data: results,
            message: `${results.success.length}/${ids.length} öğe silindi`
        };
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
